<app-loading *ngIf="isLoading"></app-loading>

<div *ngIf="simulation$ | async as simulation">
  <div *ngIf="simulation.status === 4 else processingBlock" class="action-buttons">
    <button mat-raised-button class="app-block" (click)="showResultMap()" i18n>SHOW RESULT MAP</button>
    <button mat-raised-button class="app-block" (click)="openResultTree()" [disabled]="!resultMode || isLoading" i18n>
      RESULT TREE
    </button>
    <button mat-raised-button class="app-block" (click)="download()" i18n>DOWNLOAD RESULTS</button>
  </div>
  <ng-template #processingBlock>
    <app-simulation-status [simulationId]="simulation.id" showText="true"></app-simulation-status>
  </ng-template>
</div>

<app-card-error [error]="error"></app-card-error>
